import type { ReactNode } from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

interface PageContextValue {
  context: string | null;
  setContext: (c: string | null) => void;
}

const Ctx = createContext<PageContextValue>({ context: null, setContext: () => undefined });

/** Lets a page publish its current repository/review context to the top bar. */
export function PageContextProvider({ children }: { children: ReactNode }) {
  const [context, setContext] = useState<string | null>(null);
  return <Ctx.Provider value={{ context, setContext }}>{children}</Ctx.Provider>;
}

export const usePageContextValue = () => useContext(Ctx).context;

export function useSetPageContext(value: string | null) {
  const { setContext } = useContext(Ctx);
  useEffect(() => {
    setContext(value);
    return () => setContext(null);
  }, [value, setContext]);
}
